import React, { FunctionComponent } from 'react'

import Header from '../../../shared/components/Header'
import Sidebar from '../../../shared/components/Sidebar'
import { Body, BreadCrumb, Container, Content, Title } from './styles'

const Dashboard: FunctionComponent = () => {
  return (
    <Container>
      <Header />
      <Body>
        <Sidebar />
        <Content>
          <BreadCrumb>
            <Title>Dashboard</Title>
          </BreadCrumb>
        </Content>
      </Body>
    </Container>
  )
}

export default Dashboard
